import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

export default class Terms extends Component {

  render() {
    const { route } = this.props;

    let url = route.meta.site_url;
    let owner = route.meta.site_owner;
    let site_name = route.meta.site_name;

    let intro = (
        <div>
            <h3>Scope</h3>
        <p>
        This statement applies to all { url } visitors, unless a separate terms of service is prominently displayed.
        </p>

        <h3>Your Use of the Service</h3>
        <p>
        { url } is owned and operated by { owner }. Throughout the site, the terms “we”, “us” and “our” refer to { owner }. { owner } offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all Terms & Conditions (“Terms”) stated here. If you disagree with these terms and conditions or any part of these terms and conditions, you are not permitted to use this website. If you are using the Service on behalf of an organization or entity (“Organization”), then you are agreeing to these Terms on behalf of that Organization and you represent and warrant that you have the authority to bind the Organization to these Terms. In that case, “you” and “your” refers to you and that Organization. 
        </p>
        <p> 
        You understand that you may only use the service if you are at least 13 years old. 
        </p>

        <h3>Privacy Policy</h3>
        <p>
        Our Privacy Policy describes how we handle any information you provide to us when you use our services. Through your use of the service you consent to the collection and use of your information as set forth in the Privacy Policy. 
        </p>
        </div>

    )

    let user_generated_materials = ( 
        <div>
            <h3>No Responsibility for User-Generated Materials</h3>
            <p>
            { site_name } reserves the right to monitor or review any user generated content such as postings, recordings, public and private messages, photos and discussions, however { site_name } is under no obligation to do so and assumes no responsibility or liability whatsoever arising from the content on our site nor for any error, defamation, libel, slander, omission, falsehood, obscenity, pornography, profanity, danger or inaccuracy contained in any of that content. { site_name } does not guarantee the reliability, truthfulness or accuracy of any user generated content, and does not endorse or support any opinions expressed by that content. You understand that by using the service, you may encounter or be exposed to content that is inaccurate, offensive, harmful or otherwise inappropriate. All content is the sole responsibility of the person who posted that content. 
            </p>
        </div>
    )

    let copyright_infringement = (
        <div>
        <h3>Copyright Infringement and Trademark Rights</h3>
        <p>
        We respect the intellectual property rights of others. Accordingly, we maintain a policy of removing User Submissions that violate copyright law, suspending access to the services to any user who uses the service in violation of copyright law and in appropriate circumstances terminating the account of any user who uses the services in violation of copyright law. Pursuant to Title 17 of the United States Code, Section 512, we have implemented procedures for receiving written notification of claimed copyright infringement and for processing such claims in accordance with such law. If you believe a user of the Service is infringing your copyright, please contact us via our <Link to="contact">contact form.</Link> 
        </p>
        <p>Your request must:</p>
        <ul>
            <li>
            Identify the copyrighted work alleged to have been infringed.
            </li>
            <li>
            Identify the allegedly infringing material in a sufficiently precise manner to allow us to locate that material.
            </li>
            <li>
            Contain adequate information by which we can contact you (including postal address, telephone number, and e-mail address).
            </li>
            <li>
            Contain a statement that you have a good faith belief that use of the copyrighted material is not authorised by the copyright owner, the copyright owner's agent, or the law. 
            </li>
            <li>
            Contain a statement that the information in the written notice is accurate.
            </li>
            <li>
            Contain a statement, under penalty of perjury, that you are authorised to act on behalf of the copyright owner. 
            </li>
        </ul>
        <p>
        If you believe that your trademark is being used somewhere on the Services in a way that constitutes trademark infringement, please contact us via our <Link to="contact">contact form.</Link> We ask that any complaints provide the accurate identity of the owner, how we may contact you, and the specific nature of the complaint.
        </p>
        </div>
    )

    let code_of_conduct = (
        <div>
            <h3>User Code of Conduct</h3>
            <p>
            You understand that by using the Service, you agree to follow the following rules regarding your use of the Service. 
            </p>
            <ul>
                <li>
                You are responsible for any activity and charges that occur under your username and account. You may not transfer your account to another person or entity.
                </li>
                <li>
                You are responsible for keeping your password safe and secure. By using the service you hereby agree to notify { site_name } of any breach of security or unauthorized use of your account. 
                </li>
                <li>
                You are solely responsible for your conduct on { site_name } and use of the service, and for any content, including but not limited to text, audio recordings, images and other files (collectively “Content”), that you post, share or contribute to the site. 
                </li>
                <li>
                You may not harass, threaten, abuse, impersonate or intimidate any other user of the service. 
                </li>
                <li>
                You may not use the service for any illegal or unauthorized purpose.
                </li>
                <li>
                You agree that your use of the service complies with all local laws regarding online conduct and acceptable content. 
                </li>
                <li>
                You may not collect or harvest, via manual or automated methods, any personally identifiable information, content or other information from the site. 
                </li>
                <li>
                You may not access the site or service with any automated system, including, but not limited to robots, spiders and offline readers. 
                </li>
                <li>
                You may not contact other users of the site in any way outside of the service. This includes unwanted email or other messages. 
                </li>
            </ul>
        </div>
    )

    let content_guidelines = (
        <div>
            <h3>User Generated Content Guidelines</h3>
            <p>
            You may not use the Service to upload, record, transmit, share or link Prohibited content. Prohibited content includes content or other materials that { site_name } believes: 
            </p>
            <ul>
                <li>
                Is obscene, abusive, profane, pornographic, offensive, slanderous, harassing, hateful, threatening, libelous, scandalous, defamatory, racially offensive, ethnically offensive or otherwise inappropriate. 
                </li>
                <li>
                Violates the law in any way, shape or form. 
                </li>
                <li>
                Constitutes, advocates or encourages conduct that would be considered a criminal offense, give rise to civil liability, or otherwise violate any law.
                </li>
                <li>
                Comprises or references any material that is copyrighted, protected by trade secret or otherwise subject to third party proprietary rights. 
                </li>
                <li>
                Contains malicious code that may compromise the service or any user of the service including, but not limited to, viruses, worms, trojan horses, corrupt files and dangerous code.
                </li>
                <li>
                Harms anyone, including minors and users not on the site.
                </li>
                <li>
                Links or references content, websites or materials that contain any content that would violate these guidelines.
                </li>
            </ul>
            <p> 
            All content posted on the service is subject to examination by {site_name} at any time and { site_name } retains the sole discretion to determine what content violates these guidelines. { site_name } reserves the right to edit, move or delete any content, for any reason, at any time, with or without notice. 
            </p>
        </div>
    )

    let account_termination = (
      <div>
        <h3>Account termination</h3>
        <p>
        { site_name } reserves the right to block, ban or terminate any account for breach or non-compliance of these Terms and Conditions. Termination of accounts may result in the removal of any and all data associated with that account from our servers. Individuals whose accounts are terminated and return to the service remain in breach of violations and may have any new accounts blocked, banned or terminated. 
        </p>

      </div>
    )

    let user_generated_content_tc = (
      <div>
        <h3>User Generated Content Terms and Conditions</h3>
        <p>
        You acknowledge that any content you submit to the service may be edited, removed, modified, published, transmitted and displayed by { site_name }. By submitting content to { site_name } you waive any rights you may have in having the material altered or changed in a manner not agreeable to you. All submitted content may be included on { url } or republished for marketing or promotional purposes in other formats and media including, but not limited to, advertisements, podcasts, television, radio, public display and print materials. 
        </p>
        <p> 
        By submitting content to { site_name } you grant { site_name } a perpetual, non-exclusive, worldwide, royalty free sub-licensable license to that content, which includes without limitation the right for { site_name } or any third party it designates, to use, copy, transmit, excerpt, publish, distribute, publicly display or perform, create derivative works of, host, cache, modify or adapt in any form or media now known or hereinafter developed.
        </p>
      </div>
    )

    let intellectual_property_rights = (
      <div>
        <h3>Intellectual property rights</h3>
        <p>
        Unless otherwise stated or agreed upon, we are the owner or the licensee of all intellectual property rights on this Website , and in the material published on it. For the purposes of these General Terms, “material” means material including, without limitation, text, graphics, images, video and sound material. Those works are protected by copyright and other intellectual property laws and treaties around the world. All such rights are reserved.
        </p>
        <p>
        You may view, download for caching purposes only, and print pages or other content from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
        </p>
        <p>
        You are not allowed to do any of the following without our explicit prior permission.
        </p>
        <ul>
            <li>
            Sell, rent or sub-license material from the website.
            </li>
            <li>
            Show or display any material from the website in public.
            </li>
            <li>
            Reproduce, duplicate, copy or otherwise exploit material on our website for a commercial purpose.
            </li>
            <li>
            Edit or otherwise modify the paper or digital copies of any material on the website.
            </li>
            <li>
            Download or print the material or extracts from it in a systematic or regular manner or otherwise so as to create a database in electronic or paper format comprising all or part of the material appearing on the Website.
            </li>
        </ul>
        <p>
        If you print off, copy or download any part of the Website in breach of these General Terms, your right to use the Website will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.
        </p>
        <p>
        If you wish to make any use of material on our site, please send us a message using the <Link to="contact">contact form.</Link>
        </p>
      </div>
    )

    let acceptable_use = (
      <div>
        <h3>Acceptable Use</h3>
        <p>
        You must not use our website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
        </p>
        <p>
        You must not use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
        </p>
        <p>
        You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to our website without our express written consent.
        </p>
        <p>
        You must not use our website to transmit or send unsolicited commercial communications.
        </p>
        <p>
        You must not use our website for any purposes related to marketing without our express written consent.
        </p>
      </div>
    )

    let security_breaches = (
      <div>
        <h3>No Responsibility for Security Breaches</h3>
        <p>
        Although we make an effort to secure this website, information transmitted over the internet is not always secure. Use of this website is purely at your own risk and { site_name } is not liable for any security breaches.
        </p>
      </div>
    )

    let third_party_links = (
      <div>
        <h3>Third Party Links</h3>
        <p>
        This website may contain links to third party websites. We are not responsible for the operation, content, or security of any third party websites and make no representations or warranties about the information contained on such websites.
        </p>
      </div>
    )

    let disclaimer_of_liability = (
      <div>
        <h3>Disclaimer of Liability</h3>
        <p>
        We give no warranties of any kind concerning { url } or its content. We do not warrant that { site_name } or its contents are virus free. You must take your own precautions as we accept no responsibility for any infection by virus or other contamination or anything which has destructive properties. 
        </p>
        <p> 
        { site_name } does its best to provide constant, uninterrupted access to the service, but we do not guarantee this and accept no responsibility or liability for any interruption or delay of the service. 
        </p>
      </div>
    )

    let errors = (
      <div>
        <h3>Errors, Omissions and Inaccuracies</h3>
        <p>
        Although { site_name } strives to provide the best content, occasionally the site may present information containing typographical errors, inaccuracies, or omissions that may relate to pricing, promotions, offers, or availability. Although we make reasonable efforts to ensure that all content on the site is current and contain no errors or inaccuracies, we make no representations, warranties or guarantees that the information, Contents or materials included on the site will be error-free or completely accurate or current at all times, or at any time. We reserve the right at any time in our sole discretion and without notice to correct any errors, inaccuracies or omissions to the information on the site.
        </p>
      </div>
    )

    let variation = (
      <div>
        <h3>Variation</h3>
        <p>
        We may revise these terms and conditions from time-to-time. Revised terms and conditions will apply to the use of our website from the date of the publication of the revised terms and conditions on our website. Please check this page regularly to ensure you are familiar with the current version.
        </p>
        <p>
        We aim to update the Website regularly, and may change the content at any time. If the need arises, we may suspend access to the Website or close it indefinitely. Any of the material on the Website may be out of date at any given time, and we are under no obligation to update such material.
        </p>
      </div>
    )

    let indemnity = (
      <div>
        <h3>Indemnity</h3>
        <p>
        You hereby indemnify us and undertake to keep us indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by us to a third party in settlement of a claim or dispute on the advice of our legal advisers) incurred or suffered by us arising out of any breach by you of any provision of these terms and conditions, or arising out of any claim that you have breached any provision of these terms and conditions.
        </p>
      </div>
    )

    let applicable_law = (
      <div>
        <h3>Applicable Law</h3>
        <p>
        By visiting { site_name } and using the service you agree that the Federal Arbitration Act, applicable federal law, and the laws of the State of Washington, without regard to its conflict or choice of laws principles, will govern these Terms and any dispute of any sort that might arise between you and { site_name }. 
        </p>
      </div>
    )

    let breaches_of_tc = (
      <div>
        <h3>Breaches of these Terms and Conditions</h3>
        <p>
        Without prejudice to our other rights under these terms and conditions, if you breach these terms and conditions in any way, we may take such action as we deem appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.
        </p>
      </div>
    )

    let severability = (
      <div>
        <h3>Severability</h3>
        <p>
        If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect. If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.
        </p>
      </div>
    )

    let contact = (
      <div>
        <h3>Contact</h3>
        <p>
        For more information, question about use of material on our site and all other inquiries please send us a message using the <Link to="contact">contact form.</Link>
        </p>  
      </div>
    )
    
    return (
      <div className="Terms">
        <Helmet
          title={site_name}
          meta={ [
            { name: "description", content: this.props.route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <h1>Terms & Conditions</h1>
        <Link to="/">Return home</Link>

        {intro}
        {user_generated_materials}
        {copyright_infringement}
        {code_of_conduct}
        {content_guidelines}
        {account_termination}
        {user_generated_content_tc}
        {intellectual_property_rights}
        {acceptable_use}
        {security_breaches}
        {third_party_links}
        {disclaimer_of_liability}
        {errors}
        {variation}
        {indemnity}
        {applicable_law}
        {breaches_of_tc}
        {severability}
        {contact}
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Terms/Terms.js